<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.3538 10.6462C11.4002 10.6926 11.4371 10.7477 11.4623 10.8084C11.4874 10.8691 11.5004 10.9342 11.5004 10.9999C11.5004 11.0656 11.4874 11.1307 11.4623 11.1914C11.4371 11.2521 11.4002 11.3072 11.3538 11.3537L8.35375 14.3537C8.30732 14.4001 8.25217 14.437 8.19147 14.4622C8.13077 14.4873 8.06571 14.5003 8 14.5003C7.9343 14.5003 7.86923 14.4873 7.80853 14.4622C7.74783 14.437 7.69269 14.4001 7.64625 14.3537L4.64625 11.3537C4.55243 11.2598 4.49973 11.1326 4.49973 10.9999C4.49973 10.8672 4.55243 10.74 4.64625 10.6462C4.74007 10.5523 4.86732 10.4996 5 10.4996C5.13269 10.4996 5.25993 10.5523 5.35375 10.6462L8 13.293L10.6463 10.6462C10.6927 10.5997 10.7478 10.5628 10.8085 10.5376C10.8692 10.5125 10.9343 10.4995 11 10.4995C11.0657 10.4995 11.1308 10.5125 11.1915 10.5376C11.2522 10.5628 11.3073 10.5997 11.3538 10.6462ZM5.35375 5.35366L8 2.70678L10.6463 5.35366C10.7401 5.44748 10.8673 5.50018 11 5.50018C11.1327 5.50018 11.2599 5.44748 11.3538 5.35366C11.4476 5.25984 11.5003 5.13259 11.5003 4.99991C11.5003 4.86722 11.4476 4.73998 11.3538 4.64615L8.35375 1.64615C8.30732 1.59967 8.25217 1.56279 8.19147 1.53763C8.13077 1.51246 8.06571 1.49951 8 1.49951C7.9343 1.49951 7.86923 1.51246 7.80853 1.53763C7.74783 1.56279 7.69269 1.59967 7.64625 1.64615L4.64625 4.64615C4.55243 4.73998 4.49973 4.86722 4.49973 4.99991C4.49973 5.13259 4.55243 5.25983 4.64625 5.35365C4.74007 5.44748 4.86732 5.50018 5 5.50018C5.13269 5.50018 5.25993 5.44748 5.35375 5.35366Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CaretDownUpIcon",
};
</script>
